import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EnhancedEncryptionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"enhanced_encryption"}/>
}
